<ng-container *ngIf="shipment">
    <div class="shipment-header">
        <div class="line first-line">
            <div class="part-esquerra">
                <div class="square-tag color generalstatus" [ngClass]="shipment.generalStatus"><span
                        class="internalGeneralStatus">{{ ('GENERALSTATUS.ENUM.' + (shipment.generalStatus |
                        uppercase)) | translate }}</span></div>
                <shared-copyclipboard class="square-tag shipmentKeyTag" [value]="shipment.shipmentKey">
                    {{shipment.shipmentKey}}</shared-copyclipboard>
                <div class="square-tag disponibilityMessage" *ngIf="shipment.disponibilityMessage">
                    <i class="fa fa-clock-o" aria-hidden="true"></i> {{shipment.disponibilityMessage}}
                </div>
                <div class="square-tag routetype"
                    *ngIf="shipment.isInbound || shipment.isReturn || shipment.isReverseLogistics || shipment.isNonacceptance || shipment.isOutbound || shipment.isDelegate">
                    <img *ngIf="shipment.isInbound" src="/assets/images/routetype-inbound.svg" alt="Inbound">
                    <img *ngIf="shipment.isReturn" src="/assets/images/routetype-return.svg" alt="Return">
                    <img *ngIf="shipment.isReverseLogistics" src="/assets/images/logisticaInversa.svg"
                        alt="Reverse logistics">
                    <img *ngIf="shipment.isNonacceptance" src="/assets/images/routetype-nonacceptance.svg"
                        alt="Nonacceptance">
                    <img *ngIf="shipment.isOutbound" src="/assets/images/routetype-outbound.svg" alt="Outbound">
                    <img *ngIf="shipment.isDelegate" src="/assets/images/routetype-delegate.svg" alt="Delegate">
                </div>
                <div class="square-tag broken" *ngIf="shipment.isBrokenForTrucking">
                    <i class="fa fa-chain-broken" aria-hidden="true"></i>
                </div>
                <div class="square-tag iamobserver" *ngIf="shipment.iAmObserver">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                </div>
                <div class="square-tag pending-messages" *ngIf="shipment.pendingMessagesRead > 0">
                    <i class="fa fa-commenting" aria-hidden="true"></i> {{ shipment.pendingMessagesRead }}
                </div>
            </div>
        </div>

        <div class="block flex">
            <div class="esquerra">
                <shared-shipment-item-address-maintenance type="origin"
                    titleCaption="SHARED.SHIPMENT.ITEM.MAINTENANCE.ORIGIN.CAPTION"
                    [addresses]="shipment.originAddresses" [skinAddress]="shipment.originSkinAddress"
                    [descriptionShort]="shipment.originDescriptionShort"
                    [formattedAddress]="shipment.originFormatedAddress"
                    (markerDoubleClick)="onMarkerDoubleClick($event)"
                    (manualAddressMarkerDoubleClick)="onManualAddressMarkerDoubleClick($event)">
                </shared-shipment-item-address-maintenance>
                <shared-shipment-item-address-maintenance type="destination"
                    titleCaption="SHARED.SHIPMENT.ITEM.MAINTENANCE.DESTINATION.CAPTION"
                    [addresses]="shipment.destinationAddresses" [skinAddress]="shipment.destinationSkinAddress"
                    [descriptionShort]="shipment.destinationDescriptionShort"
                    [formattedAddress]="shipment.destinationFormatedAddress"
                    (markerDoubleClick)="onMarkerDoubleClick($event)"
                    (manualAddressMarkerDoubleClick)="onManualAddressMarkerDoubleClick($event)">
                </shared-shipment-item-address-maintenance>
            </div>
            <div class="dreta">
                <shared-shipment-header [shipment]="shipment" [phase]="phase"></shared-shipment-header>
            </div>
        </div>
    </div>
    <div class="bar">
        <div class="baroptions">
            <options [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
        </div>
        <div class="baractions">
            <shared-state [(value)]="states" (stateChange)="onSelectorChangedState($event)" [readonly]="readonly">
            </shared-state>
            <actions *ngIf="!readonly" [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
        </div>
    </div>
    <div class="info component" *ngIf="'INFO'==selectedOptionId">
        <div class="block">
            <div class="notes" [innerHTML]="shipment.notesHtml" matTooltip="{{shipment.notesText}}">
            </div>
            <shared-tags-strip-component class="line tags" [tags]="shipment.userTags">
            </shared-tags-strip-component>
            <shared-tags-strip-component class="line tags only-hardman-user internal-tags"
                [tags]="shipment.internalTags">
            </shared-tags-strip-component>
            <shared-tags-strip-component class="line tags only-hardman-user" [tags]="shipment.incidentTags">
            </shared-tags-strip-component>
            <div class="grup goods">
                <div class="titol">{{'SHARED.SHIPMENT.ITEM.MAINTENANCE.GOODS.CAPTION'| translate}}</div>
                <div class="contingut">{{shipment.goods}}</div>
            </div>
            <div class="grup comments">
                <div class="titol">{{'SHARED.SHIPMENT.ITEM.MAINTENANCE.COMMENTS.CAPTION'| translate}}</div>
                <div class="contingut">{{shipment.comments}}</div>
            </div>
            <div class="grup moments">
                <div class="titol">{{'SHARED.PHASE.ITEM.MAINTENANCE.FIRSTLASTMOMENT.CAPTION'| translate}}</div>
                <div class="contingut">
                    <table class=" hardman">
                        <tr class="origin">
                            <th rowspan="2">{{'SHARED.SHIPMENT.ITEM.MAINTENANCE.ORIGIN.CAPTION' | translate}}</th>
                            <th class="header">
                                {{'SHARED.SHIPMENT.ITEM.MAINTENANCE.ORIGINFIRSTMOMENT.CAPTION' | translate}}
                            </th>
                            <td>{{shipment.originFastConditionFirstMoment | datehournotz}}</td>
                        </tr>
                        <tr class="origin">
                            <th class="header">
                                {{'SHARED.SHIPMENT.ITEM.MAINTENANCE.ORIGINLASTMOMENT.CAPTION' | translate}}
                            </th>
                            <td>{{shipment.originFastConditionLastMoment | datehournotz}}</td>
                        </tr>
                        <tr class="destination">
                            <th rowspan="2">{{'SHARED.SHIPMENT.ITEM.MAINTENANCE.DESTINATION.CAPTION' | translate}}</th>
                            <th class="header">
                                {{'SHARED.SHIPMENT.ITEM.MAINTENANCE.DESTINATIONFIRSTMOMENT.CAPTION' | translate}}
                            </th>
                            <td>{{shipment.destinationFastConditionFirstMoment | datehournotz}}</td>
                        </tr>
                        <tr class="destination">
                            <th class="header">
                                {{'SHARED.SHIPMENT.ITEM.MAINTENANCE.DESTINATIONLASTMOMENT.CAPTION' | translate}}
                            </th>
                            <td>{{shipment.destinationFastConditionLastMoment | datehournotz}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="grup conditions">
                <div class="titol">
                    {{'SHARED.SHIPMENT.ITEM.MAINTENANCE.CONDITIONS.CAPTION'| translate}}
                </div>
                <div class="contingut">
                    <shared-shipment-item-conditions-maintenance [shipment]="shipment" [phase]="phase"
                        [routeId]="routeId" (valueChange)="onEditChanged()">
                    </shared-shipment-item-conditions-maintenance>
                </div>
            </div>
        </div>
    </div>
    <shared-shipment-item-edit-maintenance *ngIf="selectedOptionId == 'EDIT'" [shipment]="shipment" [phase]="phase"
        [routeId]="routeId" (valueChange)="onEditChanged()">
    </shared-shipment-item-edit-maintenance>
    <shared-shipment-item-form-maintenance *ngIf="selectedOptionId == 'LOADFORM'" [shipment]="shipment"
        [formShipmentType]="'LoadForm'">
    </shared-shipment-item-form-maintenance>
    <shared-shipment-item-form-maintenance *ngIf="selectedOptionId == 'UNLOADFORM'" [shipment]="shipment"
        [formShipmentType]="'UnLoadForm'">
    </shared-shipment-item-form-maintenance>
    <shared-route-item-log-maintenance *ngIf="selectedOptionId == 'LOG'" [shipment]="shipment">
    </shared-route-item-log-maintenance>
    <shared-documentaryreview-documents-component class="block" *ngIf="'DOCUMENTS'==selectedOptionId"
        [parentObject]="parentObject">
    </shared-documentaryreview-documents-component>
    <shared-chat class="chats-body-zonachat chat-without-header" *ngIf="selectedOptionId == 'CHAT'" [notes]="true"
        [forcedOwnerParticipant]="forcedOwnerParticipant" (clickParticipant)="clickParticipant($event)">
    </shared-chat>
    <shared-shipment-delivery-component *ngIf="selectedOptionId == 'DELIVERY'" [shipmentId]="shipment.shipmentId">
    </shared-shipment-delivery-component>
    <shared-shipment-cmr-maintenance *ngIf="selectedOptionId == 'CMR'" [shipmentId]="shipment.shipmentId">
    </shared-shipment-cmr-maintenance>

    <shared-shipment-multi-address-component *ngIf="selectedOptionId == 'MULTIADDRESS.ORIGIN'" [shipment]="shipment"
        (valueChange)="onEditChanged()">
    </shared-shipment-multi-address-component>

    <shared-shipment-multi-address-component *ngIf="selectedOptionId == 'MULTIADDRESS.DESTINATION'"
        [shipment]="shipment" [isOrigin]="false" (valueChange)="onEditChanged()">
    </shared-shipment-multi-address-component>

    <shared-telemetry class="maintenance-component fullheight reduced" *ngIf="selectedOptionId == 'TELEMETRY'"
        [model]="'Shipment'" [modelId]="shipmentId" [dataInici]="shipment.originDateTimeStart"
        [dataFi]="shipment.destinationDateTimeEnds" [isActiveRoutes]="true"></shared-telemetry>

    <shared-statustime-component *ngIf="selectedOptionId == 'TIMES'" [shipment]="shipment">
    </shared-statustime-component>

    <shared-package-data-component *ngIf="selectedOptionId == 'ESCHENKER'" [provider]="'ESchenker'"
        [shipmentId]="shipment.shipmentId">
    </shared-package-data-component>

    <shared-package-data-component *ngIf="selectedOptionId == 'DACHSER'" [provider]="'Dachser'"
        [shipmentId]="shipment.shipmentId">
    </shared-package-data-component>

    <shared-package-component *ngIf="selectedOptionId == 'PACKAGES'" [shipment]="shipment"></shared-package-component>

</ng-container>